import React from 'react';
const hr = () =>(
    <hr style={{marginTop:'0.5rem',marginBottom:'0.5rem'}} />
)

export default hr;